import request from '@/utils/request'

/**
 * 查询拼团列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryGroupBuy(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/groupBuy.queryGroupBuy',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}